module.exports = __webpack_public_path__ + "img/pink-clouds-home.4c8e885c.jpg";